import React, { useMemo } from 'react'
import CodeEditor, { CodeEditorProps } from '@/components/CodeEditor'
import Dialog, { DialogProps } from '@/components/modals/Dialog'

export type CodePreviewModalProps = {
	value: string | Record<string, unknown>
	codeEditor: Omit<CodeEditorProps, 'value'>
} & DialogProps

const CodePreviewModal = ({
	value,
	codeEditor,
	...rest
}: CodePreviewModalProps) => {
	const { language } = codeEditor

	const formattedValue: string = useMemo(() => {
		if (language === 'json') {
			try {
				if (typeof value === 'string') {
					return JSON.stringify(JSON.parse(value), null, 2)
				}
				return JSON.stringify(value, null, 2)
			} catch (e) {
				return `Invalid json ${
					e instanceof Error ? e.message : String(e)
				}`
			}
		}
		return typeof value === 'string'
			? value
			: 'Invalid value. Object is only supported for JSON'
	}, [language, value])

	return (
		<Dialog {...rest}>
			<CodeEditor
				value={formattedValue}
				height="70vh"
				language={language}
				options={{
					readOnly: true,
				}}
				{...codeEditor}
			/>
		</Dialog>
	)
}

export default CodePreviewModal
